(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-purchase')) {
    customElements.define('bundle-purchase', class extends HTMLElement {
      connectedCallback() {
        this.radios = [...this.querySelectorAll('[data-bundle-plan] input[type="radio"]')];
        this.addButton = this.querySelector('[data-bundle-add]');
        this.shopButton = this.querySelector('[data-bundle-shop]');
        this.status = this.querySelector('[data-bundle-status]');
        this.currency = this.dataset.currency || 'USD';
        this.locale = this.dataset.locale || 'en';
        this.formatter = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency });
        this.initTimer();

        this.querySelectorAll('[data-required-choice]').forEach((select) => {
          [...select.options].forEach((option) => {
            option.dataset.originalLabel = option.textContent.trim();
            option.dataset.originalDisabled = String(option.disabled);
          });
        });

        this.radios.forEach((radio) => radio.addEventListener('change', () => this.selectPlan(radio)));
        this.querySelectorAll('[data-bundle-variant]').forEach((select) => {
          select.addEventListener('change', () => {
            this.updateChoiceRow(select);
            this.updateAddonPrice(select);
            this.updatePlanImages(select.closest('[data-bundle-plan]'));
            this.updatePrices();
          });
          select.addEventListener('click', (event) => event.stopPropagation());
        });
        this.querySelectorAll('[data-remove-choice]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.resetChoice(button);
          });
        });
        this.querySelectorAll('[data-bundle-addon-toggle]').forEach((toggle) => {
          toggle.addEventListener('change', () => {
            this.toggleAddon(toggle);
            this.updatePrices();
          });
          this.toggleAddon(toggle);
        });
        this.querySelectorAll('[data-bundle-plan]').forEach((plan) => {
          plan.addEventListener('click', (event) => {
            if (event.target.closest('select')) return;
            const radio = plan.querySelector('input[type="radio"]');
            if (!radio.checked) {
              radio.checked = true;
              this.selectPlan(radio);
            }
          });
        });
        this.addButton?.addEventListener('click', () => this.submit(false));
        this.shopButton?.addEventListener('click', () => this.submit(true));
        const initialRadio = this.radios.find((radio) => radio.checked) || this.radios[0];
        if (initialRadio) initialRadio.checked = true;
        this.querySelectorAll('[data-required-choice]').forEach((select) => this.updateChoiceRow(select));
        this.querySelectorAll('[data-bundle-plan]').forEach((plan) => this.updatePlanImages(plan));
        this.selectPlan(initialRadio);
      }

      get activePlan() {
        return this.querySelector('[data-bundle-plan].is-selected');
      }

      selectPlan(radio) {
        if (!radio) return;
        this.querySelectorAll('[data-bundle-plan]').forEach((plan) => {
          plan.classList.toggle('is-selected', plan.contains(radio));
        });
        this.status.textContent = '';
        this.updatePrices();
      }

      selectedItems() {
        const items = new Map();
        this.activePlan?.querySelectorAll('[data-bundle-variant]').forEach((select) => {
          if (select.disabled) return;
          const id = Number(select.value);
          if (id) items.set(id, (items.get(id) || 0) + 1);
        });
        const properties = { _Bundle: this.activePlan?.dataset.bundleName || 'Bundle' };
        const discount = Number(this.activePlan?.dataset.discountPercent || 0);
        if (discount > 0) properties['_Bundle discount'] = `${discount}%`;
        return [...items].map(([id, quantity]) => ({ id, quantity, properties }));
      }

      totals() {
        let discountablePrice = 0;
        let extraPrice = 0;
        let compare = 0;
        let count = 0;
        this.activePlan?.querySelectorAll('[data-bundle-variant]').forEach((select) => {
          if (select.disabled) return;
          const option = select.selectedOptions[0];
          if (!option) return;
          const optionPrice = Number(option.dataset.price || 0);
          if (select.hasAttribute('data-bundle-extra')) extraPrice += optionPrice;
          else discountablePrice += optionPrice;
          compare += Number(option.dataset.comparePrice || option.dataset.price || 0);
          if (!select.hasAttribute('data-bundle-extra')) count += 1;
        });
        const discount = Math.min(100, Math.max(0, Number(this.activePlan?.dataset.discountPercent || 0)));
        const discountedPrice = Math.round(discountablePrice * (100 - discount) / 100);
        const price = discountedPrice + extraPrice;
        compare = Math.max(compare, discountablePrice + extraPrice);
        return { price, compare, count };
      }

      money(cents) {
        return this.formatter.format(cents / 100);
      }

      initTimer() {
        const timer = this.querySelector('[data-bundle-timer]');
        if (!timer) return;
        const minutes = Math.max(1, Number(timer.dataset.durationMinutes || 15));
        const duration = minutes * 60 * 1000;
        const key = `bundle-timer-${timer.dataset.timerKey || 'default'}`;
        const readEnd = () => {
          try { return Number(window.localStorage.getItem(key) || 0); } catch (error) { return 0; }
        };
        const writeEnd = (end) => {
          try { window.localStorage.setItem(key, String(end)); } catch (error) { return end; }
          return end;
        };
        let end = readEnd();
        if (!end || end <= Date.now()) end = writeEnd(Date.now() + duration);
        const tick = () => {
          let remaining = end - Date.now();
          if (remaining <= 0) {
            end = writeEnd(Date.now() + duration);
            remaining = duration;
          }
          const totalSeconds = Math.ceil(remaining / 1000);
          const hours = Math.floor(totalSeconds / 3600);
          const minutesPart = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          timer.querySelector('[data-timer-value]').textContent = hours > 0
            ? `${String(hours).padStart(2, '0')}:${String(minutesPart).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
            : `${String(minutesPart).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        };
        tick();
        this.timerInterval = window.setInterval(tick, 1000);
      }

      updatePlanImages(plan) {
        if (!plan) return;
        const selects = [...plan.querySelectorAll('[data-bundle-variant]')];
        selects.forEach((select) => {
          const option = select.selectedOptions[0];
          const imageUrl = option?.dataset.image;
          const imageAlt = option?.dataset.imageAlt || '';
          const choiceContainer = select.closest('.bundle-plan__choice')?.querySelector('[data-bundle-choice-image]');
          if (!choiceContainer) return;
          let image = choiceContainer.querySelector('img');
          if (!image && imageUrl) {
            image = document.createElement('img');
            image.loading = 'lazy';
            choiceContainer.appendChild(image);
          }
          if (image) {
            image.hidden = !imageUrl;
            if (imageUrl) image.src = imageUrl;
            image.alt = imageAlt;
          }
        });
      }

      updateChoiceRow(select) {
        const row = select?.closest('[data-choice-row]');
        if (!row) return;
        const option = select.selectedOptions[0];
        const isChosen = Boolean(select.value);
        row.classList.toggle('is-chosen', isChosen);
        const name = row.querySelector('[data-choice-product-name]');
        if (!isChosen) {
          this.restoreChoiceOptions(select);
          if (name) name.textContent = '';
          return;
        }
        const productKey = option?.dataset.productId || option?.dataset.productTitle || '';
        const productOptions = [];
        [...select.options].forEach((candidate) => {
          if (!candidate.value) {
            candidate.hidden = true;
            candidate.disabled = true;
            return;
          }
          const candidateKey = candidate.dataset.productId || candidate.dataset.productTitle || '';
          const sameProduct = candidateKey === productKey;
          candidate.hidden = !sameProduct;
          candidate.disabled = !sameProduct || candidate.dataset.originalDisabled === 'true';
          candidate.textContent = sameProduct
            ? (candidate.dataset.variantTitle || candidate.dataset.originalLabel)
            : candidate.dataset.originalLabel;
          if (sameProduct) productOptions.push(candidate);
        });
        select.hidden = productOptions.length === 1 && productOptions[0].dataset.variantTitle === 'Default Title';
        if (name) name.textContent = option?.dataset.productTitle || '';
      }

      restoreChoiceOptions(select) {
        [...select.options].forEach((option) => {
          option.textContent = option.dataset.originalLabel || option.textContent;
          option.hidden = false;
          option.disabled = option.dataset.originalDisabled === 'true';
        });
        select.hidden = false;
        select.value = '';
      }

      resetChoice(button) {
        const row = button?.closest('[data-choice-row]');
        const select = row?.querySelector('[data-required-choice]');
        if (!row || !select) return;
        this.restoreChoiceOptions(select);
        row.classList.remove('is-chosen');
        const name = row.querySelector('[data-choice-product-name]');
        if (name) name.textContent = '';
        this.updatePlanImages(row.closest('[data-bundle-plan]'));
        this.updatePrices();
        select.focus();
      }

      toggleAddon(toggle) {
        const row = toggle?.closest('[data-bundle-addon-row]');
        const select = row?.querySelector('[data-bundle-addon-select]');
        if (!row || !select) return;
        const enabled = toggle.checked;
        row.classList.toggle('is-enabled', enabled);
        select.disabled = !enabled;
      }

      updateAddonPrice(select) {
        const row = select?.closest('[data-bundle-addon-row]');
        if (!row) return;
        const option = select.selectedOptions[0];
        const price = Number(option?.dataset.price || 0);
        const label = row.querySelector('[data-addon-price]');
        if (label) label.textContent = `+ ${this.money(price)}`;
      }

      updatePrices() {
        const plan = this.activePlan;
        if (!plan) return;
        const { price, compare, count } = this.totals();
        const current = plan.querySelector('[data-current-price]');
        const original = plan.querySelector('[data-compare-price]');
        const perItem = plan.querySelector('[data-per-item]');
        const saving = plan.querySelector('[data-saving-text]');
        if (current) current.textContent = this.money(price);
        if (original) {
          original.textContent = this.money(compare);
          original.hidden = compare <= price;
        }
        if (perItem && count) {
          perItem.textContent = `${this.money(Math.round(price / count))} ${this.dataset.perItemLabel}`;
        }
        if (saving) {
          const configuredDiscount = Number(plan.dataset.discountPercent || 0);
          const percentage = configuredDiscount > 0
            ? configuredDiscount
            : (compare > price ? Math.round((1 - price / compare) * 100) : 0);
          saving.textContent = percentage > 0 ? `${this.dataset.savingsLabel} ${percentage}%` : '';
        }
        const showPrices = this.dataset.showButtonPrices === 'true';
        const suffix = showPrices ? ` — ${this.money(price)}` : '';
        this.addButton.querySelector('[data-button-text]').textContent = `${this.dataset.addLabel}${suffix}`;
        this.shopButton.querySelector('[data-button-text]').textContent = `${this.dataset.shopLabel}${suffix}`;
      }

      setLoading(loading) {
        this.classList.toggle('is-loading', loading);
        this.addButton.disabled = loading;
        this.shopButton.disabled = loading;
      }

      async submit(goToCheckout) {
        const missingChoice = [...(this.activePlan?.querySelectorAll('[data-required-choice]') || [])]
          .find((select) => !select.value);
        if (missingChoice) {
          this.status.textContent = this.dataset.chooseError;
          missingChoice.focus();
          return;
        }
        const items = this.selectedItems();
        if (!items.length) return;
        this.setLoading(true);
        this.status.textContent = '';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Request failed');
          const discountCode = this.activePlan?.dataset.discountCode?.trim();
          if (goToCheckout) {
            const root = window.Shopify?.routes?.root || '/';
            if (discountCode) {
              const redirect = encodeURIComponent(`${root}checkout`);
              window.location.assign(`${root}discount/${encodeURIComponent(discountCode)}?redirect=${redirect}`);
            } else {
              window.location.assign(`${root}checkout`);
            }
            return;
          }
          if (discountCode) {
            try {
              await fetch(`${window.Shopify?.routes?.root || '/'}discount/${encodeURIComponent(discountCode)}`, {
                credentials: 'same-origin'
              });
            } catch (error) {
              this.status.textContent = error.message;
            }
          }
          const drawer = document.querySelector('cart-drawer');
          if (drawer?.renderContents) drawer.renderContents(data);
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
          this.status.textContent = this.dataset.successLabel;
        } catch (error) {
          this.status.textContent = error.message;
        } finally {
          if (!goToCheckout) this.setLoading(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
